import { ITicketObjectType } from "types";

export const ticketObjectList = [
    { value: ITicketObjectType.WheelieBin, text: "WheelieBin" },
    { value: ITicketObjectType.UndergroundContainer, text: "UndergroundContainer" },
    { value: ITicketObjectType.Card, text: "Card" },
    { value: ITicketObjectType.Other, text: "Other" },
];
